<template>
  <div class="x_box">
    <ol class="breadcrumb x_breadcrumb">
      <li class="breadcrumb-item active" aria-current="page">{{ $t('tax_salary') }}</li>
    </ol>
    <div class="x_header">
      <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)">
        <i class="fa fa-arrow-circle-o-left"></i>{{ $t('back') }}
      </button>
      <button type="button" class="btn btn-outline-primary btn-sm no-bor">
        <i class="fa fa-print"></i>{{$t('print')}}
      </button>
      <div class="pull-right">
        <div class="flex">
          <select class="form-control form-control-sm" v-model="request.Year" @change="toList">
            <option value="2020">2020</option>
          </select>
          <select class="form-control form-control-sm" v-model="request.Month" @change="toList">
            <option value="1">មករា</option>
            <option value="2">កុម្ភៈ</option>
            <option value="3">មីនា</option>
            <option value="4">មេសា</option>
            <option value="5">ឧសភា</option>
            <option value="6">មិថុនា</option>
            <option value="7">កក្តដា</option>
            <option value="8">សីហា</option>
            <option value="9">កញ្ញា</option>
            <option value="10">តុលា</option>
            <option value="11">វិច្ឆិកា</option>
            <option value="12">ធ្នូ</option>
          </select>
          <select class="form-control form-control-sm" v-model="request.Type" @change="toList">
            <option value="Resident">{{$t('resident')}}</option>
            <option value="Non Resident">{{$t('non_resident')}}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="x_body">
      <div class="card f_card">
        <div class="card-body">
          <div class="text-center">
            <h4 class="font-m">{{$t('tax_salary')}}</h4>
            <h5>ប្រចាំខែ {{$month(month)}} ឆ្នាំ {{$tokh(year)}}</h5>
          </div>
          <template v-if="request.Type=='Resident'">
            <table class="table table-bordered table-sm">
              <thead>
                <tr class="text-center single-bor blue">
                  <td>
                    ល.រ
                    <br />No.
                  </td>
                  <td>
                    ឈ្មោះនិយោជិក
                    <br />Name of Employee
                  </td>
                  <td>
                    សញ្ជាតិ
                    <br />Nationality
                  </td>
                  <td>
                    មុខងារ
                    <br />Function
                  </td>
                  <td>
                    ប្រាក់បៀវត្យត្រូវបើក
                    <br />Salary to be Paid
                  </td>
                  <td>
                    សហព័ន្ធ
                    <br />Spouse
                  </td>
                  <td>
                    កូនក្នុងបន្ទុក
                    <br />Minor Children
                  </td>
                  <td>
                    ទឹកប្រាក់កាត់បន្ថយ
                    <br />Allowance
                  </td>
                  <td>
                    មូលដ្ឋានគិតពន្ធ បវ
                    <br />Salary Tax Calculation Base
                  </td>
                  <td>
                    អត្រាពន្ធ
                    <br />Tax Rate
                  </td>
                  <td>
                    ពន្ធលើប្រាក់បៀវត្ស
                    <br />Tax on Salary
                  </td>
                  <td>
                    កំណត់សំគាល់
                    <br />Remarks
                  </td>
                </tr>
                <tr class="text-center single-bor">
                  <td></td>
                  <td>A</td>
                  <td>B</td>
                  <td>C</td>
                  <td>D</td>
                  <td>E</td>
                  <td>F</td>
                  <td>G = (E + F) x 150,000</td>
                  <td>H = D - G</td>
                  <td>I</td>
                  <td>J</td>
                  <td>K</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(ret, index) in records" :key="ret.Id">
                  <td class="text-center">{{index+1}}</td>
                  <td>{{ret.KhmerName}}</td>
                  <td>{{ret.Nationality}}</td>
                  <td>{{ret.Job}}</td>
                  <td class="text-right">{{$number(ret.SalaryAfterBonus, '0,0')}}</td>
                  <td class="text-center">{{ret.Spouse}}</td>
                  <td class="text-center">{{ret.Children}}</td>
                  <td class="text-right">{{$number(ret.Allowance, '0,0')}}</td>
                  <td class="text-right">{{$number(ret.SalaryForTax,'0,0')}}</td>
                  <td class="text-center">{{$number(ret.TaxRate,'0,0')}}%</td>
                  <td class="text-right">{{$number(ret.TaxOnSalary,'0,0')}}</td>
                  <td>{{ret.Remark}}</td>
                </tr>
              </tbody>
            </table>
          </template>
          <template v-else>
            <table class="table table-bordered table-sm">
              <thead>
                <tr class="text-center single-bor blue">
                  <td>
                    ល.រ
                    <br />No.
                  </td>
                  <td>
                    ឈ្មោះនិយោជិក
                    <br />Name of Employee
                  </td>
                  <td>
                    សញ្ជាតិ
                    <br />Nationality
                  </td>
                  <td>
                    មុខងារ
                    <br />Function
                  </td>
                  <td>
                    ប្រាក់បៀវត្យត្រូវបើក
                    <br />Salary to be Paid
                  </td>
                  <td>
                    អត្រាពន្ធ
                    <br />Tax Rate
                  </td>
                  <td>
                    ពន្ធលើប្រាក់បៀវត្ស
                    <br />Tax on Salary
                  </td>
                  <td>
                    កំណត់សំគាល់
                    <br />Remarks
                  </td>
                </tr>
                <tr class="text-center single-bor">
                  <td></td>
                  <td>A</td>
                  <td>B</td>
                  <td>C</td>
                  <td>D</td>
                  <td>E</td>
                  <td>F = D x E</td>
                  <td>G</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(ret, index) in records" :key="ret.Id">
                  <td class="text-center">{{index+1}}</td>
                  <td>{{ret.KhmerName}}</td>
                  <td>{{ret.Nationality}}</td>
                  <td>{{ret.Job}}</td>
                  <td class="text-right">{{$number(ret.SalaryForTax,'0,0')}}</td>
                  <td class="text-center">{{$number(ret.TaxRate,'0,0')}}%</td>
                  <td class="text-right">{{$number(ret.TaxOnSalary,'0,0')}}</td>
                  <td>{{ret.Remark}}</td>
                </tr>
              </tbody>
            </table>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      month: this.$now().format("M") - 1,
      year: this.$now().format("YYYY"),
      records: [],
      request: {
        Month: this.$now().format("M"),
        Year: this.$now().format("YYYY"),
        Type: "Resident"
      }
    };
  },
  created() {
    this.toList();
  },
  methods: {
    toList() {
      var loading = this.$loading.show();
      this.$api()
        .post("tax/salary", this.request)
        .then(res => {
          if (this.$isValid(res)) {
            this.records = res.data.Data;
          }
        })
        .finally(function() {
          loading.hide();
        });
    }
  }
};
</script>
<style scoped>
.single-bor td {
  border-bottom-width: 1px;
  line-height: 14px;
  font-size: 12px;
}
.nop {
  border: none;
}
.nop .card-body {
  padding: 0;
  overflow-x: auto;
}
.flex {
  display: flex;
}
.flex select {
  margin-left: 5px;
  width: 100px;
}
</style>